/**
 * Configuración de autenticación - Control temporal de Keycloak
 *
 * Este archivo permite deshabilitar temporalmente Keycloak en toda la aplicación
 * cambiando una sola variable de configuración.
 */
/**
 * CONFIGURACIÓN PRINCIPAL DE AUTENTICACIÓN
 *
 * Para deshabilitar Keycloak temporalmente:
 * - Cambiar KEYCLOAK_ENABLED a false
 * - Cambiar AUTH_MODE a 'mock' o 'disabled'
 */
export const KEYCLOAK_ENABLED = true; // ← CAMBIAR AQUÍ PARA HABILITAR/DESHABILITAR
export const AUTH_MODE = 'keycloak'; // 'keycloak' | 'mock' | 'disabled'
/**
 * Usuario mock para desarrollo sin Keycloak
 */
export const MOCK_USER = {
    id: 'mock-user-001',
    username: 'usuario.demo',
    email: 'usuario.demo@sysone.com',
    firstName: 'Usuario',
    lastName: 'Demo',
    name: 'Usuario Demo',
    roles: ['user', 'agent'],
    permissions: ['consulta-poliza', 'denuncia-siniestros', 'cotizadores', 'pagos'],
    realm: 'mock-realm',
};
/**
 * Configuración completa de autenticación
 */
export const authConfig = {
    enabled: KEYCLOAK_ENABLED,
    mode: AUTH_MODE,
    mockUser: MOCK_USER,
};
/**
 * Función para verificar si Keycloak está habilitado
 */
export const isKeycloakEnabled = () => {
    return authConfig.enabled && authConfig.mode === 'keycloak';
};
/**
 * Función para verificar si se debe usar usuario mock
 */
export const shouldUseMockAuth = () => {
    return !authConfig.enabled || authConfig.mode === 'mock';
};
/**
 * Función para verificar si la autenticación está completamente deshabilitada
 */
export const isAuthDisabled = () => {
    return !authConfig.enabled && authConfig.mode === 'disabled';
};
/**
 * Obtener configuración de usuario según el modo
 */
export const getUserConfig = () => {
    if (isKeycloakEnabled()) {
        return null; // Se obtendrá de Keycloak
    }
    if (shouldUseMockAuth()) {
        return authConfig.mockUser;
    }
    return null; // Sin autenticación
};
export default authConfig;
